import { Sparkles } from "lucide-react";

export const ConcertSpotlight = () => (
  <section data-testid="concert-spotlight-card" className="relative overflow-hidden px-6 py-24 sm:py-32">
    <div className="pointer-events-none absolute inset-0 bg-[#E6E1F4]/40" />
    <div className="relative mx-auto grid max-w-5xl items-center gap-12 lg:grid-cols-2">
      <div className="relative">
        <div className="polaroid animate-float-slow" style={{ transform: "rotate(-3deg)" }}>
          <span className="tape" />
          <img
            src="/photos/p31.webp"
            alt="Tina and Jayden in matching red at the sold out Bruno Mars concert, MetLife Stadium"
            loading="lazy"
            className="aspect-[4/3] w-full object-cover"
          />
          <p className="py-3 text-center font-hand text-xl text-[#4A2E35]/80">the night the silence gave up</p>
        </div>
        <div className="absolute -bottom-8 -right-2 hidden rotate-6 rounded-lg border-2 border-dashed border-[#C87D87]/60 bg-[#FFFDF9] px-5 py-3 shadow-md sm:block">
          <p className="text-[10px] font-semibold uppercase tracking-[0.2em] text-[#C87D87]">admit two</p>
          <p className="font-hand text-lg leading-tight">bruno mars, with my best friend</p>
        </div>
      </div>
      <div>
        <p className="font-hand text-2xl text-[#C87D87]">april 18th — the poster</p>
        <h2 className="mt-3 font-display text-2xl font-semibold sm:text-3xl lg:text-4xl">"I've Got the Tickets, I've Got the Ride, All I'm Missing Is You"</h2>
        <p className="mt-6 text-sm leading-relaxed text-[#4A2E35]/75 sm:text-base">
          Four months of silence ended with a poster outside my building, styled after Bruno Mars,
          cameras secretly set up in my room, and the easiest yes of my entire life. That concert
          didn't just rekindle a friendship — it proved neither of us had ever really let go.
        </p>
        <div className="mt-8 inline-flex items-center gap-2.5 rounded-full border border-[#D4A359]/50 bg-[#FFFDF9]/80 px-5 py-2.5 text-xs font-semibold text-[#4A2E35]/80">
          <Sparkles size={14} className="text-[#D4A359]" />
          Chapter 5 tells the whole story
        </div>
      </div>
    </div>
  </section>
);
